// Live Tracking Device Groups — thin wrapper around the shared GroupsManagerModal.
// All actual UI lives in /app/frontend/src/components/shared/GroupsManagerModal.jsx
// See /app/memory/groups-ui-pattern.md for the full Group UI convention.
import React from 'react';
import { GroupsManagerModal, GroupIcon } from '../shared/GroupsManagerModal';
import { deviceDisplayName } from '../../utils/deviceName';

export { GroupIcon };

export const ManageGroupsModal = ({ open, onOpenChange, api, devices, onSaved }) => (
  <GroupsManagerModal
    open={open}
    onOpenChange={onOpenChange}
    api={api}
    apiBase="/device-groups"
    items={devices}
    itemLabel={(d) => deviceDisplayName(d)}
    itemSubLabel={(d) => d.imei || ''}
    itemIdField="id"
    membershipMode="group_devices"
    allocateEndpoints={{ add: 'add-devices', remove: 'remove-devices' }}
    title="Manage Device Groups"
    itemLabelPlural="devices"
    onSaved={onSaved}
    testIdPrefix="device-groups"
  />
);

export default ManageGroupsModal;
